import SV from 'server-vars';
import { localStorage } from 'dibs-browser-storage';
import { getBuyerId } from 'dibs-cookie-jar';
import { WINDFALL_LOCAL_STORAGE_KEY } from './constants';
import getRelayEnvironemt from '../../../relayClientEnvironment';
import { setNonTradeUserToSuspectedTradeMutation } from '../../../mutations/setNonTradeUserToSuspectedTradeMutation';
import authModalLoader from '../../../utils/AuthModalLoader';

export const tradeWindfallReferralAction = () => dispatch => {
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const userId = getBuyerId(document.cookie);
    // if the user is not a trade user
    if (!isUserTypeTrade) {
        if (userId) {
            // if the user is logged in, set their trade status to SUSPECTED
            setNonTradeUserToSuspectedTradeMutation(getRelayEnvironemt(), {
                userId: userId,
            });
        } else {
            // otherwise store the windfall flag in local storage
            localStorage.setItem(WINDFALL_LOCAL_STORAGE_KEY, true);
        }

        const path = location.pathname || '';
        const isOnTradeApplicationPage = path.split('/trade/apply').length > 1;
        // if the user is not on the trade application page, launch the trade application
        if (!isOnTradeApplicationPage) {
            authModalLoader.showPostAuth({
                step: 'trade_basic_info',
                postAuthFlow: 'SUSPECTED_TRADE_APPLICATION',
            });
        }
    }

    return dispatch({ type: 'noop' });
};
